var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardIconSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "t2bnlt3z0a"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.890196 0 0 0 0 0.396078 0 0 0 0 0.062745 0 0 0 1.000000 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "yd66flgofb"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#t2bnlt3z0a)",
    transform: "translate(-14 -129) translate(-4)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#yd66flgofb)",
    transform: "translate(18 129)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.244 0.244L19.756 0.244 19.756 19.756 0.244 19.756z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M2.941 10.784h6.275V2.941H2.94v7.843zm0 6.275h6.275v-4.706H2.94v4.706zm7.843 0h6.275V9.216h-6.275v7.843zm0-14.118v4.706h6.275V2.941h-6.275z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIconSelected);
export default __webpack_public_path__ + "static/media/dashboard-icon-selected.0741459558509fc2f8168f690b7f30a6.svg";
export { ForwardRef as ReactComponent };